// AI Knowledge Store 页面的自定义 SectionFunction
// 对应 CompanyWebUIConfig.xml 中 <page name="AiVectorStore"><section name="AiVectorStore">

// 打开"文件管理"Drawer，行按钮触发
// parameter 是当前行的 vector store 数据对象
export function openFilesDrawer({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  pageComponent.setState({
    showFilesDrawer: true,
    currentVectorStore: parameter,
    filesList: []
  }, () => {
    pageComponent.loadFiles();
  });
}

// 顶部 Refresh 按钮：重新拉列表
export function refreshKnowledgeStore({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.getSectionDataByDefault();
}
